import { dataActions } from 'reducers';
import store from 'store';
import { ProductInCartTable } from './types';
import { GA_removeProductFromCart } from './gtm-utils';

export const removeCartLine = (product: ProductInCartTable) => {
    GA_removeProductFromCart(product);
    store.dispatch(dataActions.deleteFromLocalCart({ index: product.indexInCart }));
};
